<template>
  <standard-layout header="Zahlungsverkehr">
    <template v-slot:main>
      <div class="row">
        <div class="col-8">
          <payment-editor @update="loadLatestPayments"/>
        </div>
        <div class="col-4 border-left">
          <latest-payments :latest-payments="latestPayments"/>
        </div>
      </div>
    </template>
  </standard-layout>
</template>
<script>
import StandardLayout from "@/layouts/StandardLayout";
import LatestPayments from "@/components/accounting/LatestPayments";
import PaymentEditor from "@/components/accounting/PaymentEditor";
export default {
  data(){
    return {
      latestPayments: []
    }
  },
  methods: {
    loadLatestPayments() {
      this.$api.get('/accounting/account-infos', {
        params: {
          count: 10
        }
      }).then(response => {
        this.latestPayments = response.data
      }).catch(error => {
        this.handleError(error)
      })
    }
  },
  mounted() {
    this.loadLatestPayments()
  },
  components: {PaymentEditor, StandardLayout, LatestPayments}
}
</script>